<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapMutations, mapGetters} from 'vuex'
import users from '../services/users'
export default {
	name: 'Home',
	data() {
		return {
			form: {
				name: '',
				code: '',
				email: '',
			},
			errors: {}
		}
	},

	computed: {
		...mapGetters({
			'userName': 'auth/userName',
		})
	},

	methods: {
		validateForm() {
			// const reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			// // let errors = {}
			// if(!reg.test(this.form.email)) {
			// 	this.$set(this.errors, 'email', 'Formato no valido')
			// }
			if(!this.form.name) {
				this.$set(this.errors, 'name', 'Es requerido')
			}
			if(!this.form.code) {
				this.$set(this.errors, 'code', 'Es requerido')
			}
			return Object.keys(this.errors).length
		},

		clearError(key) {
			delete this.errors[key]
		},
		async register() {
			let vm = this
			let data = JSON.stringify(this.form)
				data = JSON.parse(data)
				// data.code = data.code.replace(/ /g,'')
			if(vm.validateForm()) {
				return
			}
			let user = await users.register(data)
			if(user.hasOwnProperty('_id')) {
				vm.setAuthUser(user)
				let route = sessionStorage.getItem('afterLogin')
				if(route) {
					vm.$router.push(route)
				} else {
					vm.$router.push({name: 'formation-index', params: {}})
				}
			}
		},

		...mapMutations({
			setAuthUser: 'auth/setAuthUser'
		})
	}
}
</script>

<template>
  	<div class="bg-register">
		<header class="auth__header text-center text-lg-left px-5 pt-md-5">
			<img class="logo" src="../assets/img/logo_blanco.png" alt="">
		</header>

		<div class="d-flex flex-wrap auth__wrap">
			<div class="d-none d-lg-flex col-12 col-lg-6 avatar-register">
				<img src="../assets/img/avatar_registro.png" alt="">
			</div>
			<div class="col-11 col-md-8 col-lg-6 ">
				<div class="auth__card px-5 py-4 px-lg-4">
					<form @submit.prevent="register" class="form-register px-3" action="">
						<h3 class="text-center">Ingresar</h3>
						<div class="form-group my-4" :class="{'is-invalid': errors.hasOwnProperty('name')}">
							<input type="text" class="form-control" @input="clearError('name')" placeholder="Nombre completo" v-model="form.name">
							<i class="fa fa-user" aria-hidden="true"></i>
							<div v-if="errors.hasOwnProperty('name')" class="text-danger">{{errors.name}}</div>
						</div>
						<div class="form-group my-4" :class="{'is-invalid': errors.hasOwnProperty('code')}">
							<input type="text" class="form-control" @input="clearError('code')" placeholder="Código de usuario" v-model="form.code">
							<i class="fa fa-hashtag" aria-hidden="true"></i>
							<div v-if="errors.hasOwnProperty('code')" class="text-danger">{{errors.code}}</div>
						</div>
						<!-- <div class="form-group my-4" :class="{'is-invalid': errors.hasOwnProperty('email')}">
							<input type="text" class="form-control" @input="clearError('email')"  placeholder="Correo eléctronico" v-model="form.email">
							<i class="fa fa-at" aria-hidden="true"></i>
							<div v-if="errors.hasOwnProperty('email')" class="text-danger">{{errors.email}}</div>
						</div> -->
						<div class="form-group">
							<button class="btn btn-bbva" type="submit" >ENTRAR</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

